import { Link } from 'react-router-dom';
import { BookOpen, Mail, MapPin, ExternalLink } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-foreground text-background">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Journal Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="JPRP" className="w-10 h-10 rounded" />
              <div>
                <span className="font-serif font-bold text-lg block">JPRP</span>
              </div>
            </div>
            <p className="text-sm text-background/70 leading-relaxed">
              Journal de pratiques et recherches en psychothérapie. 
              Revue scientifique en libre accès.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">Journal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background/70 hover:text-background transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/editorial-board" className="text-sm text-background/70 hover:text-background transition-colors">
                  Comité éditorial
                </Link>
              </li>
              <li>
                <Link to="/author-guidelines" className="text-sm text-background/70 hover:text-background transition-colors">
                  Instructions aux auteurs
                </Link>
              </li>
            </ul>
          </div>

          {/* Browse */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">Parcourir</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/articles" className="text-sm text-background/70 hover:text-background transition-colors">
                  Tous les articles
                </Link>
              </li>
              <li>
                <Link to="/articles?type=research" className="text-sm text-background/70 hover:text-background transition-colors">
                  Recherches empiriques
                </Link>
              </li>
              <li>
                <Link to="/articles?type=case_study" className="text-sm text-background/70 hover:text-background transition-colors">
                  Études de cas
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-sm text-background/70 hover:text-background transition-colors">
                  Ressources
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-background/70">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>contact@jprp.fr</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-background/70">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>France</span>
              </li>
            </ul>
            <div className="mt-4">
              <Link 
                to="/register" 
                className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
              >
                Soumettre un manuscrit
                <ExternalLink className="w-3 h-3" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-background/50">
            <p>
              © {new Date().getFullYear()} Journal de pratiques et recherches en psychothérapie. 
              Tous droits réservés.
            </p>
            <div className="flex items-center gap-4">
              <span>Licence CC BY 4.0</span>
              <span>•</span>
              <Link to="/privacy" className="hover:text-background">
                Confidentialité
              </Link>
              <span>•</span>
              <Link to="/terms" className="hover:text-background">
                Mentions légales
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
